import { Role } from "./role";
import { Facility } from "./facility";
import { Group } from "./group";

export class User {
    id: string;
    userName: string;
    password: string;
    firstName: string;
    middleInitial: string;
    lastName: string;
    title: string;
    phoneNumber: string;
    cell: string;
    email: string;
    description: string;
    timezone: string;
    dst: string;
    isDeleted: boolean;
    authenticationCode: string;
    oldPassword: string;
    reportPassword: string;
    allowEscalation: boolean;
    grantAllIps: boolean;
    grantEditUsers: boolean;
    dashboardhtml: string;
    comment: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    isApproved: boolean;
    lastLoginDate: any;
    isLockedOut: boolean;
    lastPasswordChangedDate: any;
    lastLockoutDate: any;
    allowWebManagerAccess: boolean;
    //failedPasswordAttemptCount: number;
    //failedPasswordAttemptWindowStart: Date;
    //failedPasswordAnswerAttemptCount: number;
    //failedPasswordAnswerAttemptWindowStart: Date;
    userFacilities: Facility[];
    userFacilityNames: string;
    roles: Role[];
    roleNames: string;
    groups: Group[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user.ts